var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-bg padding-nav " },
    [
      _c("exchange"),
      _vm._v(" "),
      _c("detailBtn", {
        staticStyle: { margin: "0.4rem 0 1.2rem 0" },
        attrs: { label: "View my History", isExpanded: _vm.showDetail },
        on: { clickHandle: _vm.setShowDetail, refresh: _vm.refresh },
      }),
      _vm._v(" "),
      _vm.showDetail
        ? _c("record-history", { ref: "recordHistory" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }